import {
    changeEvent, clickEvent, customDocumentEvent, customEvent,
    dispatchCustomEvent,
    fireChangeEvent,
    inputEvent
} from "../../../../../../../webpack/modules/events";
import {
    getOptions,
    showLoaderPriceElements,
    updatePriceElements
} from "../../../../../../../webpack/modules-optimized/product-list";
import {getNewTomSelectQuantity, initTomSelectQuantity} from "../../../../../../../webpack/modules-optimized/tomselect";
import {
    calculateCustomSizePrice,
    getSVGFactor,
    getSvgPreviewImage
} from "../../../../../../../webpack/modules-optimized/product";
import {
    hideElement,
    showElement,
    slideDown,
    slideUp
} from "../../../../../../../webpack/modules-optimized/element-visibility";
import {formatPrice} from "../../../../../../../webpack/modules-optimized/price";
import {isDesktop} from "../../../../../../../webpack/modules/devices";

clickEvent('#product-list-page .product-configuration-size[data-option-type="multiple-selectable"]', true, function(element, event) {
    event.preventDefault();
});

changeEvent('#product-list-page .product-configuration-size[data-option-type="multiple-selectable"] input[name="size"]', true, function(element) {
    let configurationMain = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let optionSize = configurationMain.querySelector('input[name="option-size"]');
    let container = element.closest('.product-configuration-size');
    let sizesSelected = container.querySelectorAll('input[name="size"]:checked');
    let previewElement = null;
    let previewText = element.dataset.previewText;

    if (configurationMain) previewElement = configurationMain.querySelector('.open-configuration .preview-option-size');

    if (sizesSelected.length > 0) {
        container.dataset.completed = 'true';
        let sizes = [];
        sizesSelected.forEach(function (size) {
            sizes.push({
                width: size.dataset.width,
                height: size.dataset.height,
                device: size.dataset.device,
                composition: size.dataset.composition,
                quantity: size.dataset.quantity
            });
        })
        optionSize.value = JSON.stringify(sizes);
    }
    else {
        container.dataset.completed = 'false';
        optionSize.value = '';
    }

    dispatchCustomEvent(
        'productSizeChanged',
        {
            'option': container,
            'container': container,
            'previewElement': previewElement,
            'previewText': previewText
        }
    );
    dispatchCustomEvent('productListProductConfigurationChanged');
    updatePriceElements(container);
});

let timeoutCustomSizeInputs = null;

inputEvent('#product-list-page .product-configuration-size[data-option-type="multiple-selectable"] input[name="custom-width"]', true, async function(element) {
    let configurationMain = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let container = element.closest('.product-configuration-size');
    let productId = container.dataset.productId;
    let customSize = element.closest('.custom-size');
    let inputWidth = element;
    let inputHeight = customSize.querySelector('.custom-size-height');
    let errorElement = container.querySelector('.error-custom-sizes');
    let size = container.querySelector('input[name="size"][value="custom-size"]');
    let headerQuantity = customSize.querySelector('button.toggle-collapse .quantity.ts-wrapper');
    let freeShippingIcon = customSize.querySelector('.tvi-free-shipping');
    let sizePreview = customSize.querySelector('.size-preview');
    let warningElement = container.querySelector('.warning');
    let factor = null;
    let onlyTextSVG = configurationMain.querySelector('input[name="onlyTextSVG"]') ? configurationMain.querySelector('input[name="onlyTextSVG"]').value === 'true' : false;
    let options = getOptions(configurationMain);

    size.checked = false;
    size.dataset.width = '';
    size.dataset.height = '';
    inputHeight.innerHTML = '';
    sizePreview.innerHTML = '';
    hideElement(freeShippingIcon);
    slideUp(warningElement)

    if (!headerQuantity.classList.contains('hidden')) headerQuantity.classList.add('hidden');

    clearTimeout(timeoutCustomSizeInputs);
    timeoutCustomSizeInputs = setTimeout(
        async function() {
            showLoaderPriceElements(container);
            customSize.querySelectorAll('.custom-price').forEach((priceContainer) => showLoaderCustomSize(priceContainer));

            if (onlyTextSVG && options['personalizedText'] && options['personalizedText'] !== '-') {
                let svgResponse = await getSvgPreviewImage(configurationMain.dataset.productId, options['personalizedText'], options['color']);
                factor = svgResponse.svgData ? svgResponse.svgData.factor : null;
            }

            dispatchCustomEvent(
                'calculateCustomHeight',
                {
                    'productId': productId,
                    'container': container,
                    'option': container,
                    'inputWidth': inputWidth,
                    'inputHeight': inputHeight,
                    'errorElement': errorElement,
                    'isFromList': true,
                    'factor': factor,
                    'inputBlur': true
                }
            );
            fireChangeEvent(size, true);
        },
        200
    );
});

changeEvent('#product-list-page .product-configuration-size[data-option-type="multiple-selectable"] .custom-size .quantity', true, function(element) {
    let quantity = parseInt(element.value);
    let container = element.closest('.custom-size');
    let size = container.querySelector('input[name="size"][value="custom-size"]');

    container.querySelectorAll('.quantity-selector').forEach(function(quantitySelector) {
        if (!quantitySelector.tomselect) return;

        quantitySelector.value = quantity;
        quantitySelector.tomselect.sync();
    });
    size.dataset.quantity = quantity;
    size.checked = quantity > 0;
    fireChangeEvent(size, true);
});

customDocumentEvent('customHeightCalculated successValidateBothSize', async function() {
    if (!document.querySelector('.product-configuration-size[data-option-type="multiple-selectable"][data-type="size"]')) return;
    let container = document.querySelector('.product-configuration-size');
    let mainContainer = isDesktop() ? container.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let productId = container.dataset.productId;
    let customSize = container.querySelector('.custom-size');
    let size = container.querySelector('input[name="size"][value="custom-size"]');
    let width = parseFloat(container.querySelector('input[name="custom-width"], input[name="bothWidth"]').value);
    let height = parseFloat(container.querySelector('.custom-size-height').innerHTML || container.querySelector('input[name="bothHeight"]').value);
    let headerQuantity = customSize.querySelector('button.toggle-collapse .quantity.ts-wrapper');
    let freeShippingIcon = customSize.querySelector('.tvi-free-shipping');
    let minPriceFreeShipping = parseInt(freeShippingIcon.dataset.minPriceFreeShipping);
    let sizePreview = customSize.querySelector('.size-preview');
    let pack = mainContainer.querySelector('input[name="option-pack"]');
    let color = mainContainer.querySelector('input[name="option-color"]');
    let supportColor = mainContainer.querySelector('input[name="option-supportColor"]');
    let warningElement = container.querySelector('.warning');

    size.checked = true;
    size.dataset.width = width;
    size.dataset.height = height;
    size.disabled = false;
    fireChangeEvent(size, false);

    let responseCalculatePrice = await calculateCustomSizePrice(
        productId,
        width,
        height,
        pack ? pack.value : null,
        color ? color.value : null,
        supportColor ? supportColor.value : null
    );
    let price = responseCalculatePrice.price;
    let warning = responseCalculatePrice.warning;

    if (warning && warning !== '') {
        warningElement.innerHTML = warning;
        slideDown(warningElement);
        container.querySelector('.body').scroll({top: warningElement.offsetTop, behavior: "smooth"});
    }

    customSize.querySelectorAll('.custom-price').forEach(function(priceContainer) {
        hideLoaderCustomSize(priceContainer);
        showCustomSizePrice(priceContainer, price);
    });

    let view = await getNewTomSelectQuantity(productId, customSize.id, price);
    customSize.querySelectorAll('.quantity-selector').forEach(function(quantity) {
        if (!quantity.tomselect) return;
        if (view) {
            let parent = quantity.parentElement;
            quantity.tomselect.destroy();
            parent.innerHTML = view;
            quantity = parent.querySelector('.quantity-selector');
            let tomSelect = initTomSelectQuantity(quantity);

            tomSelect.on('dropdown_close', function () {
                let wrapper = tomSelect.wrapper;
                let quantity = tomSelect.getValue();
                if (!size) return;
                size.dataset.quantity = quantity;
                size.checked = quantity > 0;
                fireChangeEvent(size, false);
            });
        }

        quantity.tomselect.setValue(1);
    });

    if (price >= minPriceFreeShipping) showElement(freeShippingIcon);

    headerQuantity.classList.remove('hidden');
    sizePreview.innerHTML = '(' + width + ' x ' + height + ' ' + sizePreview.dataset.unitMeasure + ')';
});
customDocumentEvent('customHeightErrorCalculate errorValidateBothSize', function() {
    if (!document.querySelector('.product-configuration-size[data-option-type="multiple-selectable"][data-type="size"]')) return;
    let container = document.querySelector('.product-configuration-size');
    let size = container.querySelector('input[name="size"][value="custom-size"]');
    let customSize = container.querySelector('.custom-size');

    size.checked = false;
    size.dataset.width = '';
    size.dataset.height = '';
    customSize.querySelectorAll('.custom-price').forEach(function(priceContainer) {
        showDefaultCustomSizePrice(priceContainer);
    });
    customSize.querySelectorAll('.quantity-selector').forEach(function(quantitySelector) {
        if (!quantitySelector.tomselect) return;
        quantitySelector.value = 0;
        quantitySelector.tomselect.sync();
    });
});

let timeoutBothSizeInputs = null;

inputEvent('#product-list-page .product-configuration-size[data-option-type="multiple-selectable"] input[name="bothWidth"], #product-list-page .product-configuration-size[data-option-type="multiple-selectable"] input[name="bothHeight"]', true, async function(element) {
    let offcanvas = element.closest('.product-configuration-size');
    let customSize = element.closest('.custom-size');
    let widthInput = customSize.querySelector('input[name="bothWidth"]');
    let heightInput = customSize.querySelector('input[name="bothHeight"]');
    let size = customSize.querySelector('input[name="size"][value="custom-size"]');

    let minSizeError = offcanvas.querySelector('.error-min-size');
    let maxSizeError = offcanvas.querySelector('.error-max-size');
    let errorWidth = offcanvas.querySelector('.error-width');
    let errorHeight = offcanvas.querySelector('.error-height');
    let headerQuantity = customSize.querySelector('button.toggle-collapse .quantity.ts-wrapper');

    let freeShippingIcon = customSize.querySelector('.tvi-free-shipping');
    let sizePreview = customSize.querySelector('.size-preview');
    let warningElement = offcanvas.querySelector('.warning');

    size.checked = false;
    size.dataset.width = '';
    size.dataset.height = '';
    sizePreview.innerHTML = '';
    hideElement(freeShippingIcon);
    slideUp(warningElement)
    if (!headerQuantity.classList.contains('hidden')) headerQuantity.classList.add('hidden');

    clearTimeout(timeoutBothSizeInputs);
    timeoutBothSizeInputs = setTimeout(
        function() {
            dispatchCustomEvent(
                'validateBothSize',
                {
                    'option': offcanvas,
                    'widthInput': widthInput,
                    'heightInput': heightInput,
                    'minSizeError': minSizeError,
                    'maxSizeError': maxSizeError,
                    'errorWidth': errorWidth,
                    'errorHeight': errorHeight
                }
            );
            fireChangeEvent(size, true);
        },
        300
    );
});

clickEvent('#product-list-page .product-configuration-size[data-option-type="multiple-selectable"] button.toggle-collapse', true, function(element, event) {
    let target = event.target;
    let collapseTarget = element.dataset.collapseTarget;

    if (target.classList.contains('.ts-wrapper') || target.closest('.ts-wrapper')) return;
    Collapse.getOrCreateInstance(collapseTarget).toggle();
});

customEvent('show.bs.collapse', '#product-list-page .product-configuration-size[data-option-type="multiple-selectable"] .custom-size .collapse',  true, function(element){
    let customSize = element.closest('.custom-size');
    let button = customSize.querySelector('button.toggle-collapse');
    button.setAttribute("aria-expanded", "true");
});

customEvent('hide.bs.collapse', '#product-list-page .product-configuration-size[data-option-type="multiple-selectable"] .custom-size .collapse',  true, function(element) {
    let customSize = element.closest('.custom-size');
    let button = customSize.querySelector('button.toggle-collapse');
    button.setAttribute("aria-expanded", "false");
});

function showLoaderCustomSize(container)
{
    hideElement(container.querySelector('.price-of'));
    hideElement(container.querySelector('.currency'));
    hideElement(container.querySelector('.price'));
    showElement(container.querySelector('.loader'));
}

function hideLoaderCustomSize(container)
{
    hideElement(container.querySelector('.loader'));
    showElement(container.querySelector('.price-of'));
    showElement(container.querySelector('.currency'));
    showElement(container.querySelector('.price'));
}

function showCustomSizePrice(container, price)
{
    price = formatPrice(price);
    hideElement(container.querySelector('.price-of'));
    hideElement(container.querySelector('.loader'));
    showElement(container.querySelector('.currency'));
    showElement(container.querySelector('.price'));
    container.querySelector('.price').innerHTML = price;
}

function showDefaultCustomSizePrice(container)
{
    let price = container.querySelector('.price');
    price.innerHTML = price.dataset.defaultValue;
    hideElement(container.querySelector('.loader'));
    showElement(container.querySelector('.currency'));
    showElement(price);
    showElement(container.querySelector('.price-of'));
}
